import React from 'react';
import TrialContact from './TrialContact';
import ScrollButton from '../ScrollButton';
import TestimonialCarousel from '../TestimonialCarousel';
import testimonials from '../../data/testimonials.json';
import TeamIntro from '../funnelContact/MeetUs';
import NextWednesdayDate from './NextWednesdayDate';
import {
  MainContent,
  HeaderWrapper,
  ContentContainer,
  HeaderContainer
} from "../StyledComponents";
import { Link as ScrollLink } from 'react-scroll';

const TrialSignupPage = () => {
  return (
    <MainContent>
      <HeaderContainer>
        <HeaderWrapper>
        </HeaderWrapper>
      </HeaderContainer>
      <ContentContainer>
         <div className="flex flex-col md:flex-row md:items-center md:gap-8 md:ml-4">
          {/* Left content: Title and text */}
          <div className="md:w-1/2">
            <h1 className='text-4xl font-bold text-custom_tertiary md:my-8'>Programmieren lernen & IT für Kids! Jetzt kostenlos ausprobieren:</h1>
            <div className='my-4 text-lg'>
              <ul className='space-y-2'>
                <li className='flex items-start'>
                  <span className='w-3 h-3 bg-yellow-400 rounded-full mr-3 mt-2 flex-shrink-0'></span>
                  <span>Jeden Mittwoch um 17 Uhr</span>
                </li>
                <li className='flex items-start'>
                  <span className='w-3 h-3 bg-yellow-400 rounded-full mr-3 mt-2 flex-shrink-0'></span>
                  <span>kostenlos und unverbindlich</span>
                </li>
                <li className='flex items-start'>
                  <span className='w-3 h-3 bg-yellow-400 rounded-full mr-3 mt-2 flex-shrink-0'></span>
                  <span>45 Minuten</span>
                </li>
              </ul>
            </div>
          </div>
          
          {/* Right content: Image and button */}
          <div className="md:w-1/2">
            <div className="flex justify-end">
              <img 
                src="../codekids/codekid1.svg" 
                alt="Kind programmiert" 
                className="w-3/4 my-0"
              />
            </div>
            <div className="flex justify-start">
              <ScrollLink
                to="contact-form-section"
                smooth={true}
                duration={800}
                offset={-100}
                className="mt-4 inline-block px-8 py-3 bg-custom_tertiary text-white text-xl font-semibold no-underline rounded-full shadow-md hover:bg-custom_tertiary/80 hover:text-black transition-colors duration-300 cursor-pointer"
              >
                Jetzt starten!
              </ScrollLink>
            </div>
          </div>
        </div>
      </ContentContainer>
      <ScrollButton />
      <ContentContainer id="contact-form-section">
        <h4 className='text-custom_neutral'>Jetzt für die nächste kostenlose Probestunde anmelden:</h4>
        <TrialContact />
          <div className='my-4 text-lg'>
            <ul className='space-y-2'>
              <li className='flex items-start'>
                <span className='w-3 h-3 bg-yellow-400 rounded-full mr-3 mt-2 flex-shrink-0'></span>
                <span>Nach dem Absenden bekommst du von uns eine Email mit allen weiteren Informationen</span>
              </li>
              <li className='flex items-start'>
                <span className='w-3 h-3 bg-yellow-400 rounded-full mr-3 mt-2 flex-shrink-0'></span>
                <span>Einfach eintragen und loslegen!</span>
              </li>
            </ul>
          </div>
        <NextWednesdayDate />
      </ContentContainer>
      <ScrollButton/>
      <ContentContainer>
        <TestimonialCarousel testimonials={testimonials} />
      </ContentContainer>
      <ScrollButton />
      <ContentContainer>
        <TeamIntro />
      </ContentContainer>
    </MainContent>
  );
};

export default TrialSignupPage;